import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
// material
import { styled, useTheme } from '@mui/material/styles'
// hooks
//
import DashboardSidebar from './DashboardSidebar'
import { RootState, useSelector } from 'redux/store'
import { useOrgTasks } from 'hooks/useOrgTasks'
import { useMyTasks } from 'hooks/useMyTasks'
import { generateID } from 'utils/generateMessageID'
import { REQUEST_MESSAGE_TYPES, Request } from 'schemas/request'
import { useSocketConnection  } from 'hooks/useSocketConnection';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64
const APP_BAR_DESKTOP = 70

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
})

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  [theme.breakpoints.down('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    marginLeft: theme.spacing(36)
  }
}))

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const theme = useTheme()
  const { notifications } = useSelector((state: RootState) => state?.notifications)
  const { user } = useSelector((state: RootState) => state?.userReducer)
  const { myTasks } = useMyTasks()
  const { orgTasks } = useOrgTasks()
  const { onSocketSend } = useSocketConnection()
  useEffect(() => {
    let org
    if (user?.orgIdentifier) {
      org = user?.orgIdentifier
      const requestAdminCreateActions: Request = {
        messageId: generateID(),
        messageType: REQUEST_MESSAGE_TYPES.AdminQueryCreateActions,
        /*@ts-ignore*/
        AdminQueryCreateActions: {
          orgIdentifier: org
        }
      }
      onSocketSend(requestAdminCreateActions)
    }
  }, [user?.orgIdentifier])

  const [, setOpen] = useState(false)

  return (
    <RootStyle>
      {
        <DashboardSidebar
          isOpenSidebar={true}
          onCloseSidebar={() => setOpen(true)}
          noOfTasks={myTasks?.length}
          noOfNotifications={notifications?.length}
          noOfOrgTasks={orgTasks?.length}
        />
      }
      <MainStyle
        sx={{
          transition: theme.transitions.create('margin', {
            duration: theme.transitions.duration.complex
          }),
          position: 'relative'
        }}
      >
        <Outlet />
      </MainStyle>
    </RootStyle>
  )
}
